export default __webpack_public_path__ + "static/media/unnamed.dc438ae1.png";